import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';

import withHelperText from "../../../hocs/with_helper_text.js";

import { FormLabel } from '@material-ui/core';

import FormFields from '../form_fields.js';

const styles = theme => ({
  root: {},
});

/**
 * Callback for inputs
 * @callback NestedModelField~onChange
 * @param {object} value changed value
 */

 /**
 * Use for display nested model's fields
 * @name NestedModelField
 * @param {object} props React component properties
 * @param {object} props.value Nested model's value
 * @param {HTMLElement} [props.displayName] Field's display name
 * @param {NestedModelField~onChange} props.onChange On change handler
 * @param {NestedModelFieldDescription} props.parentField Parent field, described nested model
 * @param {boolean} [props.allowAutoSave = false] Enabling auto saving for form fields. If it equals true, 
 * all changes for {@link TextField|TextField's}, {@link PasswordField|PasswordField's} and {@link WYSIWYGField|WYSIWYGField's} will be fired after delay
 * @param {number} [props.autoSaveTimeout = 500] Delay for saving life edit fields. Useful only if props.allowAutoSave == true
 * @param {number} [props.defaultWeight = 12] Default weight of inputs inside form fields
 * @param {boolean} [props.readOnly = false] Does field is read only?
 * @param {object} [props.errorData] Error messages after submit form to server
*/

class NestedModelField extends React.Component {

  constructor(props) {
    super(props);

    this.value = {...{}, ...props.value};

    this.state = {
      
    }

    this.onChangeNestedModel = this.onChangeNestedModel.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    return {
      parentField: { ...props.parentField },
      formFields: [...props.formFields ],
      errorData: { ...props.errorData },
      readOnly: props.readOnly
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state.formFields) !== JSON.stringify(nextState.formFields) ||
           JSON.stringify(this.state.parentField) !== JSON.stringify(nextState.parentField) ||
           JSON.stringify(this.state.errorData) !== JSON.stringify(nextState.errorData) ||
           this.state.readOnly !== nextState.readOnly;
  }

  componentDidUpdate(prevProps, prevState) {
    if(JSON.stringify(this.value || {}) !== JSON.stringify(prevProps.value || {})) {
      this.value = { 
        ...this.props.value 
      };
      this.forceUpdate();
    }
  }

  onChangeNestedModel(changedItem) {
    const { onChange } = this.props;
    this.value = {...changedItem};
    if(onChange) {
      onChange(changedItem);
    }
  }

  render() {
    const { classes, className, autoSaveTimeout, allowAutoSave, displayName } = this.props;

    const { formFields, errorData, readOnly } = this.state;

    return <div className = { clsx(classes.root, className) } >
      {
        displayName && displayName !== "" &&
        <FormLabel>
          { displayName }
        </FormLabel>
      }
      {
        <FormFields formFields = { formFields } 
                    item = { this.value } 
                    onItemChange = { this.onChangeNestedModel } 
                    errorData = { errorData }
                    autoSaveTimeout = { autoSaveTimeout }
                    allowAutoSave = { allowAutoSave }
                    defaultWeight = { this.props.defaultWeight }
                    readOnly = { readOnly } />
      }
    </div>
  }
}

NestedModelField.propTypes = {
  formFields: PropTypes.arrayOf(PropTypes.object).isRequired,
  parentField: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,

  autoSaveTimeout: PropTypes.number,
  allowAutoSave: PropTypes.bool,
  value: PropTypes.object
};

NestedModelField.defaultProps = {
  autoSaveTimeout: 500,
  allowAutoSave: false,
  defaultWeight: 12
}

export default compose(withHelperText, withStyles(styles))(NestedModelField)
